import React from "react";

const LineBottom = ({ color }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 200">
      <path fill={color} fillOpacity="1" d="M0,32L1440,128L1440,0L0,0Z"></path>
    </svg>
  );
};

export default LineBottom;
